import styled, { keyframes } from 'styled-components';

const transition = keyframes`
0%{background-position:0% 200%}
50%{background-position:100% 79%}
100%{background-position:0% 22%}
`
const Card = styled.div`
  height: 64px;
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background .3s;
  box-shadow: 0px 2px 4px rgb(51 51 51 / 8%);
  will-change: background;
  ${props => props.darkMode ? `
    background-color: #f4d769;
  ` : null}
  cursor: pointer;
`

const OTCCard = styled.div`
  height: 45px;
  width: 50%;
  border: 1px solid #000000;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background .3s;
  will-change: background;
  ${props => props.darkMode ? `
    background-color: #f4d769;
  ` : null}
  cursor: pointer;
`;

const OTCCardCard = styled.div`
  width: 50%;
  color: white;
  font-size: 18px;
  height: 100%;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.div`
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 16px;
  line-height: 21px;
  margin-right: 10px;
`

const ImgWrapper = styled.div`
  img {
    width: 85px;
  }
`;

const Wrapper = styled.div`
  height: 45px;
  display: flex;
  flex-wrap: nowrap;
  width: 200px;
  
`;

export {
	Card,
	ImgWrapper,
	OTCCard,
	OTCCardCard,
	Text,
	Wrapper,
}
